import icons from '../../../assets/icons';
import { colors } from '../../../style/vars';
import classNames from 'classnames';
import { style } from './icon.linaria';
function Icon({ className, icon, size, strokeColor, backgroundColor, fillColor, }) {
    if (!icon) {
        return null;
    }
    const IconComponent = typeof icon === 'string' ? icons[icon] : icon;
    return (<IconComponent style={{ background: backgroundColor }} color={strokeColor} stroke={strokeColor} fill={fillColor} className={classNames(['hj-icon', style, size, className])}/>);
}
Icon.defaultProps = {
    className: null,
    strokeColor: colors.iconBaseColor,
    fillColor: 'transparent',
    backgroundColor: colors.transparent,
    size: 'large',
    icon: undefined,
};
export default Icon;
